// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDAZUaTIiPGGq6UsLG9JyTCAEb8cwZdzGk",
  authDomain: "simple-firebase-authenti-61a3d.firebaseapp.com",
  projectId: "simple-firebase-authenti-61a3d",
  storageBucket: "simple-firebase-authenti-61a3d.appspot.com",
  messagingSenderId: "690730711679",
  appId: "1:690730711679:web:9debbe03016a13536c5d4a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;